import { Injectable } from '@angular/core';

import {pontosStorage, tiposPontos} from "./data.service";

@Injectable()
export class PontoService {

    constructor(
    ) { }

    //session
    setSessionStorage(item: any) {
        let object: string = JSON.stringify(item);
        sessionStorage.setItem(pontosStorage + '-new', object);
    }

    getSessionStorage() {
        let item: string = sessionStorage.getItem(pontosStorage + "-new");
        return JSON.parse(item);
    }

    clearSessionStorage() {
        sessionStorage.removeItem(pontosStorage + "-new");
    }

    checkTipo(tipo:  number) {
        let tipos: any[] = tiposPontos;
        let x: number, lenX: number;
        for (x = 0, lenX = tipos.length; x < lenX; x++) {
            if (tipo === tipos[x].Key) {
                tipo = tipos[x];
                break;
            }
        }

        return tipo;
    }

}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/viagens/pontos/shared/ponto.service.ts
 **/